import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const resetRootScroll = () => {
  const scrollOptions = { top: 0, left: 0, behavior: "auto" };

  window.scrollTo(scrollOptions);

  [
    document.scrollingElement,
    document.documentElement,
    document.body,
    document.getElementById("root"),
  ]
    .filter(Boolean)
    .forEach((element) => {
      element.scrollTop = 0;
      element.scrollLeft = 0;
    });
};

const ScrollToTop = () => {
  const { pathname, search, hash, state } = useLocation();

  useEffect(() => {
    if (!("scrollRestoration" in window.history)) return undefined;

    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useEffect(() => {
    if (state?.preserveScrollPosition) return;

    if (hash) {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (target) {
        requestAnimationFrame(() => {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      }
      return;
    }

    resetRootScroll();
    requestAnimationFrame(resetRootScroll);
  }, [pathname, search, hash, state]);

  return null;
};

export default ScrollToTop;
